import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import * as actions from '../actions/actions';
import { List, Map } from 'immutable';
import FormField from './FormField';
import { Panel, Button } from 'react-bootstrap';
import _ from 'lodash';

class URLLaunchOptions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      showQaLinksWarning: false
    };

    // this is so we know how deep we are in a map, i.e. { hi: { hello: { whats: "up" } } }
    this.currentLevel = 0;

    // this is so we always know who is the parent: whats parent is hello, and hello is hi.
    // this allows us to pass on a string to the FormField component
    // with the actual chain of parents, so taking the above example we would have:
    // parent = "hi.hello.whats"
    this.parentChain = '';

    this.urlLaunchOptionChanged = this.urlLaunchOptionChanged.bind(this);
  }

  handleQALinksChanged = function (name, value) {
    let actualValue = value
    if (value === 'select') {
      actualValue = ''

      // using setState callback so we only set the warning after it has been shown
      this.setState({
        showQaLinksWarning: true
      }, () => {
        setTimeout(() => {
          this.setState({
            showQaLinksWarning: false
          })
        }, 2500)
      })
    }

    this.props.launchOptionChanged2('extraParams', actualValue);
  }

  urlLaunchOptionChanged = function (name, value, parentName) {
    console.log('url - launchOptionChanged', name, value);

    let newName = [name];
    let paramName = name;
    let paramValue = value;

    if (parentName) {
      newName.unshift(parentName);
      paramName = parentName + '.' + name;
    }

    if (typeof value === 'string' && value.indexOf(',') > -1) {
      let arrayValues = value.split(',');
      // array of numbers
      if (!isNaN(arrayValues[0])) {
        paramValue = '[' + arrayValues + ']';
      } else {
        // in a array of strings, each value needs to be in quotes to be passed as url param
        let aux = arrayValues.map(v => '"' + v + '"');
        paramValue = '[' + aux + ']';
      }
    }

    this.props.URLlaunchOptionChanged2(newName, value);

    let param = this.updateQueryStringParameter(
      this.props.launchOptions.get('extraParams'),
      paramName,
      paramValue
    );
    this.props.launchOptionChanged2('extraParams', param);
  };

  // adapted from: https://stackoverflow.com/a/6021027
  updateQueryStringParameter = function (uri, key, value) {
    let re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
    let separator = '&';
    if (uri.match(re)) {
      return uri.replace(re, '$1' + key + '=' + value + '$2');
    } else {
      return uri + separator + key + '=' + value;
    }
  };

  generateFormFieldFromObject(urlParams, parent) {
    let itemsToReturn = [];

    urlParams.entrySeq().forEach((v, k) => {
      let key = v[0];
      let value = v[1];
      let label = _.startCase(key);

      //console.log(parent)
      //console.log(key, value);

      // add a space between fields so it's not confusing (p.e. sub-forms, ie, map within map)
      if (!parent && k !== 0) {
        //itemsToReturn.push("---");
        itemsToReturn.push(<br key={`br-${key}`} />);
      }

      if (Map.isMap(value)) {
        this.currentLevel = this.currentLevel + 1;

        let CustomH = `h${this.currentLevel + 3}` // custom react tag to dynamically create the <h /> tag starting at <h4 />
        if (this.currentLevel === 1) {
          itemsToReturn.push(<CustomH key={`h${this.currentLevel + 3}-${key}`}>{label}</CustomH>);
        } else {
          this.parentChain = this.parentChain + parent + '.'
          itemsToReturn.push(<CustomH key={`h${this.currentLevel + 3}-${key}`}>{label}</CustomH>);
        }

        return itemsToReturn.push(this.generateFormFieldFromObject(value, key));
      } else {
        if (this.currentLevel > 1) {
          parent = this.parentChain + parent
        }


        if (List.isList(value)) {
          if (List.isList(value.first()) || Map.isMap(value.first())) {
            console.error('Invalid object!', value);
          } else {
            /*itemsToReturn.push(
              <FormField key={key} type={'select'} parent={parent} configID={key} label={label} options={value} onChange={this.urlLaunchOptionChanged}/>
            );*/
            itemsToReturn.push(
              <FormField
                key={key}
                type={'text'}
                parent={parent}
                configID={key}
                label={label}
                value={value.toArray().toString()}
                placeholder={'Enter values separated by commas...'}
                onChange={this.urlLaunchOptionChanged}
              />
            );
          }
        } else if (typeof value === 'string') {
          if (value.length > 60) {
            itemsToReturn.push(
              <FormField
                key={key}
                type={'textarea'}
                parent={parent}
                configID={key}
                label={label}
                value={value}
                placeholder={'Enter text...'}
                onChange={this.urlLaunchOptionChanged}
              />
            );
          } else {
            itemsToReturn.push(
              <FormField
                key={key}
                type={'text'}
                parent={parent}
                configID={key}
                label={label}
                value={value}
                placeholder={'Enter text...'}
                onChange={this.urlLaunchOptionChanged}
              />
            );
          }
        } else if (typeof value === 'number') {
          itemsToReturn.push(
            <FormField
              key={key}
              type={'number'}
              parent={parent}
              configID={key}
              label={label}
              value={value}
              placeholder={'Enter a number...'}
              onChange={this.urlLaunchOptionChanged}
            />
          );
        } else if (typeof value === 'boolean') {
          itemsToReturn.push(
            <FormField
              key={key}
              type={'checkbox'}
              parent={parent}
              configID={key}
              label={label}
              value={value}
              onChange={this.urlLaunchOptionChanged}
            />
          );
        }

        // reset the currentLevel
        this.parentChain = '';
        this.currentLevel = 0;
      }
    });

    return itemsToReturn;
  }

  render() {
    return (
      <div>
        <Button
          bsStyle="primary"
          block
          onClick={() => this.setState({ open: !this.state.open })}
        >
          URL Options
        </Button>
        <Panel collapsible expanded={this.state.open}>
          <div className="select-qa-links">
            <h4>Select pre-defined URL options</h4>
          </div>
          <div className="qa-links">
            <a href="https://confluence.playzido.com/display/PW/Wrapper+2.0.0+QA+Links" target="_blank" rel="noopener noreferrer">Confluence QA Links</a>
            <FormField
              configID="qaLinks"
              label="QA Links"
              type="select"
              options={this.props.state.environment_information.get('qaLinks')}
              onChange={this.handleQALinksChanged.bind(this)}
            />
            {
              this.state.showQaLinksWarning && <span>Your previous URL costumization has been deleted.</span>
            }
          </div>
          <div className="customize-url-yourself">
            <h4>or customize the URL yourself</h4>
          </div>
          {this.generateFormFieldFromObject(this.props.urlLaunchOptions)}
        </Panel>
      </div>
    );
  }
}

URLLaunchOptions.propTypes = {
  gameInfo: PropTypes.object.isRequired,
  config: ImmutablePropTypes.map,
  urlLaunchOptions: ImmutablePropTypes.map,
  launchOptions: ImmutablePropTypes.map
};

const mapStateToProps = state => {
  return {
    state
  };
};

const mapDispatchToEvents = dispatch => {
  return {
    URLlaunchOptionChanged2: (name, value) => {
      dispatch(actions.setURLLaunchOptions({ name: name, value: value }));
    },
    launchOptionChanged2: (name, value) => {
      dispatch(actions.setLaunchOptions({ name: name, value: value }));
    }
  };
};

const URLLaunchOptionsConnected = connect(
  mapStateToProps,
  mapDispatchToEvents
)(URLLaunchOptions);

export default URLLaunchOptionsConnected;



// WEBPACK FOOTER //
// ./src/components/URLLaunchOptions.js